import Glightbox from 'glightbox';

export default () => {
  const lightbox = Glightbox();
};
